import { render, staticRenderFns } from "./lights.vue?vue&type=template&id=0d9f68f4"
import script from "./lights.vue?vue&type=script&lang=js"
export * from "./lights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports